import { SVGProps } from 'react';

const MonitorCog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 17v4m2.305-13.47.923-.382m0-2.296-.923-.383m2.547-1.241-.383-.924m.383 6.468-.383.923m2.679-6.467.383-.924m-.001 7.392-.382-.924m1.624-3.92.924-.383m-.924 2.679.924.383M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7M8 21h8m5-15a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default MonitorCog;
